import React from "react";
import THEProblem from "../DSA/problem";

function WhyWeBuiltThis() {
  return (
    <div id="why-we-built-this">
      <THEProblem
        label="WHY WE BUILT THIS"
        title="Agents were carrying real borrowers to lenders over WhatsApp. Nothing was tracked. Commission arrived late, if at all."
        description="So we built the missing layer: verification at submission, routing that knows which desk funds what, and a payout record nobody has to argue about."
      />
    </div>
  );
}

export default WhyWeBuiltThis;
